import { PreChatActionTypes } from './preChat.types';

const productsByStatusRequest = ({ withCancelled, withPending }) => ({ type: PreChatActionTypes.PRODUCT_BY_STATUS_REQUEST, payload: { withCancelled, withPending } });
const productsByStatusSuccess = () => ({ type: PreChatActionTypes.PRODUCT_BY_STATUS_SUCCESS });
const productsByStatusFailure = () => ({ type: PreChatActionTypes.PRODUCT_BY_STATUS_FAILURE });

const diagnosticRequest = ({
  enabledSubscriptionInDiagnostic,
  enabledCloudflare,
  enableDuplicateOrders,
  enableAlertCreditRefund,
  enabledCloudflareDelayedAlert,
}) => ({
  type: PreChatActionTypes.GET_DIAGNOSTIC_REQUEST,
  payload: {
    enabledSubscriptionInDiagnostic,
    enabledCloudflare,
    enableDuplicateOrders,
    enableAlertCreditRefund,
    enabledCloudflareDelayedAlert,
  },
});
const diagnosticSuccess = () => ({ type: PreChatActionTypes.GET_DIAGNOSTIC_SUCCESS });
const diagnosticFailure = () => ({ type: PreChatActionTypes.GET_DIAGNOSTIC_FAILURE });

const setDiagnostic = diagnostic => ({
  type: PreChatActionTypes.SET_DIAGNOSTIC,
  payload: { diagnostic },
});

const setProductsByStatus = productsList => ({
  type: PreChatActionTypes.SET_PRODUCT_BY_STATUS,
  payload: { productsList },
});

const diagnosticLoading = isLoading => ({
  type: PreChatActionTypes.SET_DIAGNOSTIC_LOADING,
  payload: isLoading,
});

const productsLoading = isLoading => ({
  type: PreChatActionTypes.SET_PRODUCTS_BY_STATUS_LOADING,
  payload: isLoading,
});

const diagnosticReload = () => ({
  type: PreChatActionTypes.RELOAD_DIAGNOSTIC,
});

const setInvoiceId = invoiceId => ({
  type: PreChatActionTypes.SET_INVOICE_ID,
  payload: invoiceId,
});

const setHoldDomainRedirect = redirect => ({
  type: PreChatActionTypes.SET_HOLD_REDIRECT,
  payload: redirect,
});

const setScreenToShowInPreChat = screen => ({
  type: PreChatActionTypes.SET_SCREEN_TO_SHOW_IN_PRECHAT,
  payload: screen,
});

const isBillingGenerated = generated => ({
  type: PreChatActionTypes.BILLING_GENERATED,
  payload: generated,
});

const isReactivationRedirect = redirect => ({
  type: PreChatActionTypes.REACTIVATION_REDIRECT,
  payload: redirect,
});

const setTrustReactivationInvoiceId = invoiceId => ({
  type: PreChatActionTypes.SET_TRUST_REACTIVATION_INVOICE_ID,
  payload: invoiceId,
});

const setSubscriptionToCancel = productId => ({
  type: PreChatActionTypes.SET_SUBSCRIPTION_TO_CANCEL,
  payload: productId,
});

const setSubscriptionToChangePaymentMethod = productId => ({
  type: PreChatActionTypes.SET_SUBSCRIPTION_TO_CHANGE_PAYMENT_METHOD,
  payload: productId,
});

const redirectManageSubscription = isRedirect => ({
  type: PreChatActionTypes.SET_SUBSCRIPTION_REDIRECT_FROM_PRECHAT,
  payload: isRedirect,
});

const setTosRedirect = isRedirect => ({
  type: PreChatActionTypes.SET_TOS_REDIRECT,
  payload: isRedirect,
});

const setVpsRedirect = isRedirect => ({
  type: PreChatActionTypes.SET_VPS_REDIRECT,
  payload: isRedirect,
});

const setVpsProductId = productId => ({
  type: PreChatActionTypes.SET_VPS_PRODUCT_ID,
  payload: productId,
});

const setVpsTermsAccepted = accepted => ({
  type: PreChatActionTypes.SET_VPS_TERMS_ACCEPTED,
  payload: accepted,
});


const productDetailsRequest = data => ({ type: PreChatActionTypes.GET_PRODUCT_DETAILS_REQUEST, payload: data });

const productDetailsSuccess = () => ({ type: PreChatActionTypes.GET_PRODUCT_DETAILS_SUCCESS });

const productDetailsFailure = () => ({ type: PreChatActionTypes.GET_PRODUCT_DETAILS_FAILURE });

const productDetailsLoading = isLoading => ({
  type: PreChatActionTypes.SET_PRODUCT_DETAILS_LOADING,
  payload: isLoading,
});

const productDetailsSet = data => ({
  type: PreChatActionTypes.SET_PRODUCT_DETAILS,
  payload: data,
});

const onEppKeyFlowSet = onFlow => ({
  type: PreChatActionTypes.SET_EPP_KEY_FLOW,
  payload: onFlow,
});

const onReservedDomainFlow = onFlow => ({
  type: PreChatActionTypes.SET_RESERVED_DOMAIN_FLOW,
  payload: onFlow,
});

const getWeekDayRequest = () => ({
  type: PreChatActionTypes.GET_WEEK_DAY_REQUEST,
});

const setWeekDay = weekDay => ({
  type: PreChatActionTypes.SET_WEEK_DAY,
  payload: weekDay,
});

const getWeekDaySuccess = () => ({
  type: PreChatActionTypes.GET_WEEK_DAY_SUCCESS,
});

const getWeekDayFailure = () => ({
  type: PreChatActionTypes.GET_WEEK_DAY_FAILURE,
});


const setShowPreChat = bool => ({
  type: PreChatActionTypes.SET_SHOW_PRE_CHAT,
  payload: bool,
});

const setActiveChat = bool => ({
  type: PreChatActionTypes.SET_ACTIVE_CHAT,
  payload: bool,
});

const setTicketType = ticketType => ({
  type: PreChatActionTypes.SET_TICKET_TYPE,
  payload: ticketType,
});

const startChatbotRequest = () => ({
  type: PreChatActionTypes.START_CHATBOT_REQUEST,
});

const startChatbotSuccess = () => ({
  type: PreChatActionTypes.START_CHATBOT_SUCCESS,
});

const startChatbotFailure = () => ({
  type: PreChatActionTypes.START_CHATBOT_FAILURE,
});

const setChatbotSessionId = sessionId => ({
  type: PreChatActionTypes.SET_CHATBOT_SESSION_ID,
  payload: sessionId,
});

const sendMessageToChatbot = ({ message, retry }) => ({
  type: PreChatActionTypes.SEND_CHATBOT_MESSAGE_REQUEST,
  payload: { message, retry },
});

const sendMessageToChatbotSuccess = () => ({
  type: PreChatActionTypes.SEND_CHATBOT_MESSAGE_SUCCESS,
});

const sendMessageToChatbotFailure = () => ({
  type: PreChatActionTypes.SEND_CHATBOT_MESSAGE_FAILURE,
});

const setChatbotMessage = message => ({
  type: PreChatActionTypes.SET_CHATBOT_MESSAGE,
  payload: message,
});

const evaluateAnswerRequest = ({ evaluation, messageId }) => ({
  type: PreChatActionTypes.EVALUATE_CHATBOT_ANSWER_REQUEST,
  payload: { evaluation, messageId },
});

const evaluateAnswerSuccess = () => ({
  type: PreChatActionTypes.EVALUATE_CHATBOT_ANSWER_SUCCESS,
});

const evaluateAnswerFailure = () => ({
  type: PreChatActionTypes.EVALUATE_CHATBOT_ANSWER_FAILURE,
});

const startChat = () => ({
  type: PreChatActionTypes.START_CHAT_SESSION_REQUEST,
});

const startChatSuccess = () => ({
  type: PreChatActionTypes.START_CHAT_SESSION_SUCCESS,
});

const startChatFailure = () => ({
  type: PreChatActionTypes.START_CHAT_SESSION_FAILURE,
});

const finishChat = () => ({
  type: PreChatActionTypes.FINISH_CHAT_SESSION_REQUEST,
});

const finishChatSuccess = () => ({
  type: PreChatActionTypes.FINISH_CHAT_SESSION_SUCCESS,
});

const finishChatFailure = () => ({
  type: PreChatActionTypes.FINISH_CHAT_SESSION_FAILURE,
});

const chatStatus = () => ({
  type: PreChatActionTypes.CHAT_STATUS_REQUEST,
});

const chatStatusSuccess = () => ({
  type: PreChatActionTypes.CHAT_STATUS_SUCCESS,
});

const chatStatusFailure = () => ({
  type: PreChatActionTypes.CHAT_STATUS_FAILURE,
});

export const forceOpenSupport = ({ bool, n8nParams }) => ({
  type: PreChatActionTypes.N8N_FORCE_OPEN_SUPPORT,
  payload: { bool, n8nParams },
});

const actions = {
  diagnostic: {
    get: diagnosticRequest,
    set: setDiagnostic,
    success: diagnosticSuccess,
    failure: diagnosticFailure,
    loading: diagnosticLoading,
    reload: diagnosticReload,
  },
  preChat: {
    setScreen: setScreenToShowInPreChat,
    setShowPreChat,
  },
  invoice: {
    set: {
      invoiceId: setInvoiceId,
      holdDomainRedirect: setHoldDomainRedirect,
    },
  },
  trustReactivation: {
    billingGenerated: isBillingGenerated,
    redirect: isReactivationRedirect,
    setInvoiceId: setTrustReactivationInvoiceId,
  },
  productByStatus: {
    request: productsByStatusRequest,
    success: productsByStatusSuccess,
    failure: productsByStatusFailure,
    loading: productsLoading,
    set: setProductsByStatus,
  },
  subscription: {
    setSubscriptionToCancel,
    setSubscriptionToChangePaymentMethod,
    redirectManageSubscription,
  },
  tos: {
    redirect: setTosRedirect,
  },
  vps: {
    redirect: setVpsRedirect,
    productId: setVpsProductId,
    termsAccepted: setVpsTermsAccepted,
  },
  productDetails: {
    get: productDetailsRequest,
    success: productDetailsSuccess,
    failure: productDetailsFailure,
    loading: productDetailsLoading,
    set: productDetailsSet,
  },
  weekDay: {
    get: getWeekDayRequest,
    set: setWeekDay,
    success: getWeekDaySuccess,
    failure: getWeekDayFailure,
  },
  eppKeyGen: {
    onFlow: onEppKeyFlowSet,
  },
  reservedDomain: {
    onFlow: onReservedDomainFlow,
  },
  chat: {
    setActiveChat,
    start: startChat,
    startSuccess: startChatSuccess,
    startFailure: startChatFailure,
    finish: finishChat,
    finishSuccess: finishChatSuccess,
    finishFailure: finishChatFailure,
    status: chatStatus,
    statusSuccess: chatStatusSuccess,
    statusFailure: chatStatusFailure,
  },
  tickets: {
    setTicketType,
  },
  chatbot: {
    startRequest: startChatbotRequest,
    startSuccess: startChatbotSuccess,
    startFailure: startChatbotFailure,
    setSession: setChatbotSessionId,
    sendMessage: sendMessageToChatbot,
    sendMessageSuccess: sendMessageToChatbotSuccess,
    sendMessageFailure: sendMessageToChatbotFailure,
    setChatbotMessage,
    evaluateAnswerRequest,
    evaluateAnswerSuccess,
    evaluateAnswerFailure,
  },
  n8n: {
    forceOpenSupport,
  },
};

export default actions;
